export default class EditorialInput {
    constructor () {
      this.titulo = null
      this.descricao = null
      this.data = new Date().toISOString().substr(0, 10)
      this.ativa = 'S'
      this.publicado = null
      this.autor_id = null
      this.data_publicacao = null
    }
  }
